/* PM Black Friday hero countdown (17/10/2026) — snippets/pm-bf-hero.liquid */
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function init(root) {
    if (root.__pmBfh) return; root.__pmBfh = true;
    var start = Date.parse(root.getAttribute('data-start'));
    var end = Date.parse(root.getAttribute('data-end'));
    if (isNaN(start) || isNaN(end)) return;
    var label = root.querySelector('[data-cd-label]');
    var sr = root.querySelector('[data-cd-sr]');
    var el = { d: root.querySelector('[data-cd="d"]'), h: root.querySelector('[data-cd="h"]'), m: root.querySelector('[data-cd="m"]'), s: root.querySelector('[data-cd="s"]') };
    if (!el.d) return;
    var cd = root.querySelector('.pm-bfh__cd');
    var timer;
    function tick() {
      var now = Date.now(), target, txt;
      if (now < start) { target = start; txt = 'Ξεκινά σε'; }
      else if (now <= end) { target = end; txt = 'Λήγει σε'; }
      else { if (cd) cd.hidden = true; clearInterval(timer); return; }
      var left = Math.max(0, Math.floor((target - now) / 1000));
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      el.d.textContent = d; el.h.textContent = pad(h); el.m.textContent = pad(m); el.s.textContent = pad(s);
      if (label && label.textContent !== txt) label.textContent = txt;
      if (sr) sr.textContent = txt + ' ' + d + ' ημέρες και ' + h + ' ώρες';
    }
    tick(); timer = setInterval(tick, 1000);
  }
  function boot() { var n = document.querySelectorAll('[data-pm-bfh]'); for (var i = 0; i < n.length; i++) init(n[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
